import { FC, useState } from "react";
import ModalContainer from "../ModalContainer";
import Colors from "~/constants/colors";
import Image from "next/image";
import { GET_SIZE_GUIDE } from "~/data/product/gql";
import { useLazyQuery, useQuery } from "@apollo/client";
import Text from "~/components/Text";

interface SizeGuideModalProps {

  sku?: string;
}

const SizeGuideModal: FC<SizeGuideModalProps> = ({  sku }) => {
  const [openSize, setOpenSize] = useState(false);
  const {data}: any = useQuery(GET_SIZE_GUIDE, {
    fetchPolicy: 'network-only',
    variables:{
      sku
    }
  })
  
const sizeGuide = data?.SizeGuide

  return (
    <>
      <Text
        type="body-2"
            className="underline font-bold text-gray-400 cursor-pointer"
            onClick={() => setOpenSize(true)}
          >
            SIZE GUIDE
      </Text>
    <ModalContainer
      open={openSize}
      onClose={()=>setOpenSize(false)}
      title="Size Guide"
      titleColor={Colors.HEADER_BG}

    >
      <div className="relative w-full aspect-[512/211]">
        <p>
          This is an approximate conversion table to help you find your size.
        </p>
        {sizeGuide?.length > 0 ? (
          sizeGuide.map((item:any) => {
            return <div dangerouslySetInnerHTML={{ __html: item.size_guide }} />;
          })
        ) : (
          <p className="d-flex justify-content-center">
            Don&rsquo;t have information to display
          </p>
        )}
      </div>
    </ModalContainer>
    </>
  );
};

export default SizeGuideModal;
